import React from 'react';
import './radiobox.scss';

const CheckBox = ({ isChecked, setIsChecked, value, name }) => {
  return (
    <div>
      <input
        onChange={(e) => setIsChecked(e.target.checked)}
        checked={isChecked}
        className="submit-check-input"
        type="checkbox"
        value={value}
        name={name}
      />
    </div>
  );
};

export default CheckBox;
